import React from 'react';
import { useParams } from 'react-router-dom';
import DevoteeSponsorshipReport from './devoteeSponsorshipReport';
import DevoteeInformation from './devoteeInformation';
import DevoteeDonationsReports from './devoteeDonationsReports';
import PoojaReports from './pooja/poojaReports';
import PriestReports from './priestReports';
import TreasuryReports from './treasuryReports';
import SystemReports from './systemReports';
import Volunteers from './volunteers';
import EventRegstration from './eventRegstration';
import FrontDesk from './frontDesk';
import PriestScheduleReport from '../priestSchedule/priestScheduleReport';

const ReportSectionRouters: React.FunctionComponent = () => {
    const { reportSectionType } = useParams();

    let componentToRender: JSX.Element;

    switch (reportSectionType) {
        case 'Devotee Sponsorship Report':
            componentToRender = <DevoteeSponsorshipReport />;
            break;
        case 'Devotee Information':
            componentToRender = <DevoteeInformation />;
            break;
        case 'Devotee Donations Reports':
            componentToRender = <DevoteeDonationsReports />;
            break;
        case 'Pooja Report':
            componentToRender = <PoojaReports />;
            break;
        case 'Priest Report':
            componentToRender = <PriestReports />;
            break;
        case 'Treasury Report':
            componentToRender = <TreasuryReports />;
            break;
        case 'System Report':
            componentToRender = <SystemReports />;
            break;
        case 'Volunteers':
            componentToRender = <Volunteers />;
            break;
        case 'Event Regstration':
            componentToRender = <EventRegstration />;
            break;
        case 'Front Desk':
            componentToRender = <FrontDesk />;
            break;
        case 'Priest Schedule Consolidated':
            componentToRender = <PriestScheduleReport />;
            break;
        default:
            componentToRender = <div>Page not found</div>;
    }

    return <>{componentToRender}</>;
};

export default ReportSectionRouters